import {
  Paper,
  Select,
  Title,
  Text,
  Flex,
  Center,
  Loader,
  Group,
} from "@mantine/core";
import { formatDate } from "@medplum/core";
import { Loading, useMedplum } from "@medplum/react";
import { IconChevronRight } from "@tabler/icons-react";
import { forwardRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EEpic from "../../assets/img/epic.svg";
import cerner from "../../assets/img/cerner.svg";
import aaathena from "../../assets/img/athenahealth.svg";
import others from "../../assets/img/others.svg";
import EpicSelect from "../../assets/img/EpicPatint.svg";
import cernerSelecr from "../../assets/img/CernerPatient.svg";
import aaathenaSelect from "../../assets/img/AthenaPatient.svg";
import { PatientNotFound } from "../Patient/PatientVisits/DataNotFound";

export function DiagnosticReportList() {
  const medplum = useMedplum();
  const navigate = useNavigate();
  const [patientList, setPatientList] = useState<any>([]);
  const [selectedPatient, setSelectedPatient] = useState<any>(null);
  const [reportsList, setReportsList] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
      const [isLoading, setIsLoading] = useState<boolean>(true);


  useEffect(() => {
    getPatientList();
    getselectedPatientEhrType(selectedPatient);
  }, []);

  useEffect(() => {
    setIsFetching(true);
    setReportsList([]);
    getReports(selectedPatient);
  }, [selectedPatient]);

  const getReports = async (id: any) => {
    const reports = await medplum.searchResources(
      "DiagnosticReport",
      "subject=" + id
    );
    setReportsList(reports);
    setIsFetching(false);
  };

  const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if ((res?.use === "official" || res?.use === "usual") && name === "--") {
          name = res?.text || res?.given[0];
        } 
      });
      if (name === "--") name = patientData[0]?.text || patientData[0]?.given || "--"
      if (typeof name !== "string") {
        name = String(name);
      }
    }
    return name;
  }
  const getPatientList = async () => {
    setIsLoading(true)
    const res = await medplum.searchResources("Patient", "_count=500");
    const patientData = res.map((patient) => {
      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding) => coding.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item) => item.system && item.system.includes("athena")
      );
      let ehrtype = "";
      if (
        patient?.identifier?.find(
          (id) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
        )
      ) {
        ehrtype = "EPIC";
      } else if (containsCerner) {
        ehrtype = "Cerner";
      } else if (containsAthena) {
        ehrtype = "Athena Health";
      } else {
        ehrtype = "Others";
      }
      let EHRIcon;
      switch (ehrtype) {
        case "EPIC":
          EHRIcon = (
            <img
              src={EpicSelect}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="EPIC"
            />
          );
          break;
        case "Cerner":
          EHRIcon = (
            <img
              src={cernerSelecr}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Cerner"
            />
          );
          break;
        case "Athena Health":
          EHRIcon = (
            <img
              src={aaathenaSelect}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Athena"
            />
          );
          break;
        default:
          EHRIcon = (
            <img
              src={others}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Others"
            />
          );
      }
      return {
        label: getPatientName(patient.name),
        value: patient.id,
        ehr: ehrtype,
        icon: EHRIcon,
      };
    });
    setSelectedPatient(patientData[0].value);
    setIsLoading(false)
    setPatientList(patientData);
  };

  const getSelectedPaitentName = (id: string) => {
    let res = patientList.filter((patient: any) => {
      return patient.value === id;
    });
    return res[0].label;
  };
  const getselectedPatientEhrType = (id: string) => {
    let selectedPatientss = patientList.find(
      (patient: any) => patient.value === id
    );
    if (selectedPatientss) {
      let ehrtypes = selectedPatientss.ehr;

      if (ehrtypes === "EPIC") {
        return (
          <img
            src={EpicSelect}
            style={{
              marginRight: "10px",
              width: "30px",
              height: "30px",
            }}
            alt="Epic EHR"
          />
        );
      } else if (ehrtypes === "Cerner") {
        return (
          <img
            src={cernerSelecr}
            style={{
              marginRight: "20px",
              width: "150px",
            }}
            alt="Cerner"
          />
        );
      } else if (ehrtypes === "Athena Health") {
        return (
          <img
            src={aaathenaSelect}
            style={{
              marginRight: "10px",
              width: "30px",
            }}
            alt="Athena HEalth"
          />
        );
      } else if (ehrtypes === "Others") {
        return (
          <img
            src={others}
            style={{
              marginRight: "30px",
              width: "30px",
            }}
            alt="Others"
          />
        );
      } else {
        return (
          <img
            src={others}
            style={{
              marginRight: "30px",
              width: "30px",
            }}
            alt="Others"
          />
        ); // or handle the case of unsupported EHR type accordingly
      }
    } else {
      return "";
    }
  };
  interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string;
    value: any;
    ehr: string;
    icon: any;
  }
  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ label, value, ehr, icon, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <Group
          noWrap
          sx={{
            justifyContent: "space-between",
            height: "30px",
            width: "100%",
          }}
        >
          <div>
            <Text>{label}</Text>
          </div>
          <div>{icon}</div>
        </Group>
      </div>
    )
  );

  return (
    <>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Title size="26px" weight={700}>
          Diagnostic Reports
        </Title>
        <Select
          label="Select patient"
          placeholder={isLoading ? "Loading..." : "Search Diagnostic Reports"}
          required={true}
          rightSection={isLoading ? <Loader size={"sm"} /> : ""}
          data={patientList}
          mt="lg"
          size="lg"
          radius="md"
          value={selectedPatient}
          onChange={(val) => {
            setSelectedPatient(val);
          }}
          clearable={true}
          sx={{
            ".mantine-Select-itemsWrapper": {
              paddingRight: "10px",
            },
          }}
          searchable
          itemComponent={SelectItem}
        />
        <Title size="18px" mt="lg" weight={700}>
          Diagnostic Reports List
        </Title>
        {reportsList.map((report: any) => (
          <Flex
            justify={"space-between"}
            align={"center"}
            pt={"16px"}
            pb={"16px"}
            pl={"10px"}
            pr={"10px"}
            bg={"rgba(241, 249, 255, 1)"}
            mt="md"
            mb="md"
            sx={{ borderRadius: "4px", cursor: "pointer" }}
            onClick={() =>
              navigate(
                `./${report.id}?name=${getSelectedPaitentName(selectedPatient)}`
              )
            }
          >
            {reportsList.length===0 && <PatientNotFound patient="Patient"/>}
            <div>
              <Text weight={500} mb={4}>
                {report.code?.text}
              </Text>
              <Text c="gray.6">
                {formatDate(report.meta?.lastUpdated as string)}
              </Text>
            </div>
            <IconChevronRight />
          </Flex>
        ))}
        {reportsList?.length === 0 && !isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Text size="xl" color="dimmed">
              No results
            </Text>
          </Center>
        )}
        {isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Loader />
          </Center>
        )}
      </Paper>
    </>
  );
}
